import { apiClient } from '~/api/client';

type Params = {
  city: string;
  county: string;
};

type IndexResponse = string[];

export const index = async (params: Params) =>
  apiClient.get<IndexResponse>(`/addresses/cities`, { params });
